//@ts-check
import { makeAutoObservable, observable, reaction } from "mobx";
import { CloseModal, ShowAlert, ShowModal } from "Utils/CommonFunctions";
import UtilityRequests from "Utils/Requests/UtilityRequests";
import AppStore from "./AppStore";

class TasksStore {
    /** @type {PrepareDownloadFileState} */
    taskState;
    /** @type {string | null} */
    currentTaskId;
    /** @type {any} */
    currentModalState;
    exportProgressModalOpened;

    constructor() {
        makeAutoObservable(this, {
            currentModalState: observable.ref,
        });

        this.taskState = {
            tasks: {}
        };
        this.currentTaskId = null;
        this.exportProgressModalOpened = false;
        this.currentModalState = null;
    }

    /**
     * @param {PrepareDownloadFileState} taskState
     */
    SetState(taskState) {
        this.taskState = taskState;

        let exportTask = this.currentDownloadingTask;
        if (exportTask == null ||
            this.currentModalState !== AppStore.modalSettings) {
            this.CancelCurrentDownloadingTask();
        }
        else if (exportTask.isCompleted) {
            if (this.exportProgressModalOpened) {
                this.exportProgressModalOpened = false;
                CloseModal();
            }

            if (exportTask.error)
                ShowAlert("error", exportTask.error);

            if (exportTask.isCompletedSuccessfully) {
                UtilityRequests.DownloadPreparedFile(exportTask.taskId);
            }

            this.currentTaskId = null;
        }
    }

    /**
     * @param {PrepareDownloadFileTask} task
     * @param {import("Components/Common/modalWindow").ModalWindowProps} modalState
     */
    SetCurrentDownloadingTask(task, modalState) {
        this.currentTaskId = task.taskId;
        this.taskState.tasks[task.taskId] = task;

        this.exportProgressModalOpened = true;
        this.currentModalState = modalState;
        ShowModal(modalState);
    }

    CancelCurrentDownloadingTask() {
        if (this.currentTaskId) {
            UtilityRequests.CancelPreparedFile(this.currentTaskId);
        }
        this.currentTaskId = null;
        this.currentModalState = null;

        if (this.exportProgressModalOpened)
            CloseModal();
        this.exportProgressModalOpened = false;
    }

    get currentDownloadingTask() {
        if (!this.currentTaskId)
            return null;

        return this.taskState.tasks[this.currentTaskId];
    }
}

export default new TasksStore();